import {Image} from '@coolcolduk/ui-image';
import {Box, Grid, Paper, Typography} from '@mui/material';
import {motion} from 'framer-motion';
import {SITE_TITLE} from '../../constants';

export default function AboutProduct() {
  return (
    <Paper component={motion.div} whileHover={{scale: 1.02}} elevation={3} sx={{p: 4, borderRadius: 4}}>
      <Typography variant="h3" component="h2" gutterBottom>
        Product Overview
      </Typography>
      <Grid container spacing={4} alignItems="center">
        <Grid size={{xs: 12, md: 6}}>
          <Grid container direction="column" spacing={4}>
            <Typography variant="body1">
              Etsy Seller Tool is a comprehensive suite of features designed to streamline your Etsy shop management.
              From bulk title and tag optimization to order alerts and analytics, our tool is built to save you time and
              increase your sales.
            </Typography>
            <Typography variant="body1">
              We&apos;re constantly evolving and adding new features based on seller feedback, ensuring that our tool
              remains at the forefront of Etsy shop management technology.
            </Typography>
          </Grid>
        </Grid>
        <Grid size={{xs: 12, md: 6}}>
          <Box sx={{position: 'relative', height: '300px', width: '100%'}}>
            <Image
              src="/about_product.png"
              alt={`${SITE_TITLE} Dashboard`}
              sx={{'& > img': {objectFit: 'cover', borderRadius: '8px'}}}
            />
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}
